import styled from "styled-components";
import BackgroundUrl from "@/assets/images/Background pattern decorative.png";
import { em } from "@abel-technologies-as/utils";

const LoginWrapper = styled.section`
	min-width: 768px;
	min-height: 768px;
	background-image: url(${BackgroundUrl});
	background-size: 100% 100%;
	background-position: center;
	display: flex;

	align-items: center;
	justify-content: center;

	@media (max-width: 760px) {
		min-width: 100%;
		padding: 10px;
	}
`;

const Container = styled.div`
	width: 363px;
	display: flex;
	align-items: center;
	flex-direction: column;

	button {
		width: 100%;
		margin-bottom: 16px;
	}

	svg {
		margin-bottom: 24px;
	}

	h2 {
		font-family: Branding-Medium, sans-serif !important;
		line-height: ${em(44, 36)};
		font-size: 36px;
		font-weight: 600;
		text-align: center;
		color: var(--text-primary);
		margin-bottom: 12px;
	}

	p {
		font-weight: 400;
		text-align: center;
		font-size: 16px;
		color: var(--text-secondary);
		margin-bottom: 32px;
	}

	.issue-signing {
		font-size: 14px;
		line-height: ${em(20, 14)};
	}

	.issue-signing a,
	.issue-signing a:visited,
	.issue-signing a:hover,
	.issue-signing a:active,
	.no-underline,
	.no-underline:visited,
	.no-underline:hover,
	.no-underline:active,
	span {
		font-size: 14px;
		line-height: ${em(20, 14)};
		font-weight: 600;
		color: var(--text-brand-secondary);
		text-decoration: none;
	}
`;

const WrapperMessage = styled.div`
	width: calc(100% + 100px);
`;

export { LoginWrapper, Container, WrapperMessage };
